import { CheckCircle2, AlertTriangle, XCircle, MessageCircleQuestion } from "lucide-react";

const STATUS = {
  groen: { icon: CheckCircle2, label: "Informatie gevonden", cls: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "🟢" },
  geel: { icon: AlertTriangle, label: "Mogelijke afwijking / controle aanbevolen", cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "🟡" },
  rood: { icon: XCircle, label: "Niet te beoordelen op basis van beschikbare informatie", cls: "bg-red-50 text-red-800 border-red-200", dot: "🔴" },
  verduidelijking: { icon: MessageCircleQuestion, label: "Verduidelijkende vraag", cls: "bg-sky-50 text-sky-800 border-sky-200", dot: "🔵" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || STATUS.rood;
  const Icon = s.icon;
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${s.cls}`}>
      <Icon className="w-3.5 h-3.5" />
      {s.label}
    </span>
  );
};
